import React from 'react';
import { Button } from './ui/button';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';
import { ShoppingCart } from 'lucide-react';

const ProductCard = ({ product, compact = false }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.stopPropagation();
    addToCart(product);
    toast.success(`${product.nome} adicionado ao carrinho!`);
  };

  const isImported = product.categoria === 'Importados';
  const imageUrl = product.imagens?.[0] || product.url_imagem;

  if (compact) {
    return (
      <div 
        className="rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-200"
        style={{ 
          backgroundColor: isImported ? '#1a1a1a' : '#fff',
          border: isImported ? '1px solid #333' : '1px solid #eee',
          cursor: 'pointer'
        }}
        data-testid={`product-card-${product.id}`}
      >
        <div style={{ aspectRatio: '1/1', overflow: 'hidden' }}>
          <img
            src={imageUrl}
            alt={product.nome}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            data-testid={`product-image-${product.id}`}
          />
        </div>
        <div style={{ padding: '0.5rem' }}>
          <h3 
            style={{ 
              fontSize: '0.8rem',
              fontWeight: '600',
              marginBottom: '0.25rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              color: isImported ? '#fff' : '#000'
            }}
            data-testid={`product-name-${product.id}`}
          >
            {product.nome}
          </h3>
          <p 
            style={{ 
              fontSize: '0.9rem',
              fontWeight: 'bold',
              color: isImported ? '#E8DCC4' : '#000',
              marginBottom: '0.375rem'
            }}
            data-testid={`product-price-${product.id}`}
          >
            R$ {product.preco.toFixed(2)}
          </p>
          <Button
            onClick={handleAddToCart}
            size="sm"
            style={{
              width: '100%',
              fontSize: '0.7rem',
              padding: '0.375rem',
              backgroundColor: isImported ? '#E8DCC4' : '#000',
              color: isImported ? '#000' : '#fff'
            }}
            data-testid={`add-to-cart-${product.id}`}
          >
            <ShoppingCart size={12} style={{ marginRight: '0.25rem' }} />
            Adicionar
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="flex-shrink-0 w-40 md:w-48 rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
      style={{ backgroundColor: isImported ? '#000' : '#fff', cursor: 'pointer' }}
      data-testid={`product-card-${product.id}`}
    >
      <div className="aspect-square overflow-hidden">
        <img
          src={imageUrl}
          alt={product.nome}
          className="w-full h-full object-cover"
          data-testid={`product-image-${product.id}`}
        />
      </div>
      <div className="p-3">
        <h3 
          className="text-sm md:text-base font-semibold mb-1 line-clamp-2"
          style={{ 
            fontFamily: 'Inter, sans-serif',
            color: isImported ? '#fff' : '#000'
          }}
          data-testid={`product-name-${product.id}`}
        >
          {product.nome}
        </h3>
        <p 
          className="text-xs mb-2"
          style={{ color: isImported ? '#E8DCC4' : '#666' }}
          data-testid={`product-category-${product.id}`}
        >
          {product.categoria}
        </p>
        <div className="flex flex-wrap gap-1 mb-2">
          {product.tags?.slice(0, 2).map((tag, idx) => (
            <span
              key={idx}
              className="text-xs px-2 py-0.5 rounded-full"
              style={{ 
                backgroundColor: isImported ? '#333' : '#E8DCC4',
                color: isImported ? '#E8DCC4' : '#000'
              }}
              data-testid={`product-tag-${idx}`}
            >
              {tag}
            </span>
          ))}
        </div>
        <p 
          className="text-lg font-bold mb-3"
          style={{ 
            fontFamily: 'Playfair Display, serif',
            color: isImported ? '#E8DCC4' : '#000'
          }}
          data-testid={`product-price-${product.id}`}
        >
          R$ {product.preco.toFixed(2)}
        </p>
        <Button
          onClick={handleAddToCart}
          className="w-full text-sm"
          style={{
            backgroundColor: isImported ? '#E8DCC4' : '#000',
            color: isImported ? '#000' : '#fff'
          }}
          data-testid={`add-to-cart-${product.id}`}
        >
          <ShoppingCart className="w-4 h-4 mr-1" />
          Adicionar
        </Button>
      </div>
    </div>
  );
};

export default ProductCard;
